/**
 * @doc Editor
 */
export enum NotificationType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}

export type NotificationTypeStrings = 'success' | 'error' | 'warning' | 'info'

export enum NotificationPresetTypes {
  REPEATER_EDITOR_MAX_ITEMS = 'repeaterMaxItemsEditorLimitation',
}

export type NotificationPresetTypeStrings = 'repeaterMaxItemsEditorLimitation'
